// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper_GE5T_"};